import {
  HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@cbo/environments/environment';
import { catchError, type Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { HttpAlertService } from '@td/components/alert/http-alert.service';
import Keycloak from 'keycloak-js';
import { SKIP_ERROR_ALERT } from './http-context-tokens';

export function httpErrorsInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  keycloak = inject(Keycloak),
  httpAlertService = inject(HttpAlertService),
  router = inject(Router),
): Observable<HttpEvent<unknown>> {
  const skipAlert = request.context.get(SKIP_ERROR_ALERT);

  return next(request).pipe(
    catchError((response) => {
      if (!(response instanceof HttpErrorResponse)) {
        return throwError(() => response);
      }

      console.warn('HTTP request failed', response);

      switch (response.status) {
        case HttpStatusCode.Unauthorized: {
          keycloak.clearToken();
          keycloak.login({
            redirectUri: `${window.location.origin}${environment.app_path}`,
          });
          break;
        }
        case HttpStatusCode.Forbidden: {
          if (!router.url.includes('/errors/no-access')) {
            router.navigateByUrl('/errors/no-access');
          }
          break;
        }
        default: {
          if (!skipAlert) {
            httpAlertService.show(response);

            if (request.method === 'GET') {
              router.navigateByUrl('/errors/page-load', { skipLocationChange: true });
            }
          }
        }
      }

      return throwError(() => response);
    }),
  );
}
